import api from ".";
import cookiesModifier from "../utils/cookies";

import { ISaveNotificationComponent } from "../types/custom_notifications";


export const saveNotificationComponent = async (data: ISaveNotificationComponent) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post(`/notification-components`, data);
        return res.status;
    } catch (error) {
        throw error;
    }
};

export const deleteNotificationComponent = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`/notification-components/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
};